import React, { useEffect, useState } from "react";
import api, { inr, formatApiError } from "../../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { toast } from "sonner";

const STATUSES = ["confirmed", "packed", "out-for-delivery", "delivered", "cancelled"];
const SLOT = { "same-day": "Same Day", "next-day": "Next Day", "store-pickup": "Pickup" };
const BADGE = {
  confirmed: "bg-gold/20 text-forest", packed: "bg-blue-100 text-blue-700",
  "out-for-delivery": "bg-orange-100 text-orange-700", delivered: "bg-green-100 text-green-700",
  cancelled: "bg-red-100 text-red-700",
};

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [expanded, setExpanded] = useState(null);

  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    try { await api.put(`/admin/orders/${id}/status`, { status }); toast.success(`Order marked ${status}`); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="fade-in" data-testid="admin-orders">
      <h1 className="font-serif text-4xl text-forest mb-1">Orders</h1>
      <p className="text-muted-foreground text-sm mb-8">{orders.length} total orders</p>

      {orders.length === 0 ? <p className="text-muted-foreground">No orders yet.</p> : (
        <div className="bg-white border border-border rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-forest text-cream text-left"><tr>
              <th className="p-4">Order</th><th className="p-4">Customer</th><th className="p-4">Slot</th><th className="p-4">Total</th><th className="p-4">Date</th><th className="p-4">Status</th>
            </tr></thead>
            <tbody>
              {orders.map((o) => (
                <React.Fragment key={o.id}>
                  <tr className="border-b border-border cursor-pointer hover:bg-sand/40" onClick={() => setExpanded(expanded === o.id ? null : o.id)} data-testid={`order-row-${o.order_number}`}>
                    <td className="p-4 font-medium text-forest">{o.order_number}</td>
                    <td className="p-4">{o.customer.name}<div className="text-xs text-muted-foreground">{o.customer.phone}</div></td>
                    <td className="p-4 text-muted-foreground">{SLOT[o.delivery_slot]}</td>
                    <td className="p-4">{inr(o.total)}</td>
                    <td className="p-4 text-muted-foreground text-xs">{new Date(o.created_at).toLocaleDateString("en-IN")}</td>
                    <td className="p-4" onClick={(e) => e.stopPropagation()}>
                      <Select value={o.status} onValueChange={(v) => updateStatus(o.id, v)}>
                        <SelectTrigger className={`w-40 h-8 text-xs rounded-full border-0 ${BADGE[o.status] || "bg-sand"}`} data-testid={`status-select-${o.order_number}`}><SelectValue /></SelectTrigger>
                        <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s} className="text-xs capitalize">{s.replace(/-/g, " ")}</SelectItem>)}</SelectContent>
                      </Select>
                    </td>
                  </tr>
                  {expanded === o.id && (
                    <tr className="bg-sand/30"><td colSpan={6} className="p-4">
                      <div className="grid md:grid-cols-2 gap-4 text-sm">
                        <div>
                          <div className="text-xs uppercase tracking-wider text-muted-foreground mb-1">Items</div>
                          {o.items.map((i, idx) => <div key={idx} className="text-forest">{i.name} ({i.variant}) × {i.qty} — {inr(i.price * i.qty)}</div>)}
                          {o.coupon_code && <div className="text-xs text-gold mt-1">Coupon {o.coupon_code}: − {inr(o.discount)}</div>}
                        </div>
                        <div>
                          <div className="text-xs uppercase tracking-wider text-muted-foreground mb-1">Delivery Address</div>
                          <div className="text-forest">{o.customer.address}, {o.customer.pincode}</div>
                          {o.customer.landmark && <div className="text-muted-foreground">Landmark: {o.customer.landmark}</div>}
                          <div className="text-muted-foreground mt-1">Payment: {o.payment_method} • Delivery: {o.delivery_charge === 0 ? "Free" : inr(o.delivery_charge)}</div>
                        </div>
                      </div>
                    </td></tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
